import { defineMessages } from 'react-intl';

export default defineMessages({
  yourSearch: {
    id: 'global_search',
    defaultMessage: 'Your search',
  },
  yourSearchCars: {
    id: 'global_title_search_cars',
    defaultMessage: '{%s} used cars',
    description: 'cars',
  },
  yourSearchJobs: {
    id: 'global_jobs_page_title_what',
    defaultMessage: '{%s} job offers',
    description: 'jobs',
  },
  yourSearchJobsWhere: {
    id: 'global_jobs_page_title_where',
    defaultMessage: 'Job offers in {%s}',
    description: 'jobs',
  },
  yourSearchJobsWhatWhere: {
    id: 'global_jobs_page_title_what_where_2vars',
    defaultMessage: '{%1$s} job offers in {%2$s}',
    description: 'jobs',
  },
  yourSearchProducts: {
    id: 'global_products_title',
    defaultMessage: 'Second hand {%s} for sale',
    description: 'products',
  },
  // @todo: pending of product decision and API keywords implementation
  // yourSearchProductsWhere: {
  //   id: 'global_products_title_onlywhere',
  //   defaultMessage: 'Classified ads in {%1$s} {%2$s}',
  //   description: 'products',
  // },
  yourSearchProductsPets: {
    id: 'global_products_title_pets',
    defaultMessage: '{%s} for sale',
    description: 'products',
  },
  // @todo: pending of product decision and API keywords implementation
  // yourSearchProductsPetsGeo: {
  //   id: 'global_products_title_pets_geo',
  //   defaultMessage: 'Pets in {%s}',
  //   description: 'products',
  // },
});



// WEBPACK FOOTER //
// ./app/components/shared/Titles/messages.js